/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Component, EventEmitter, Input, Output, TemplateRef, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-chip',
    templateUrl: './chip.component.html',
    styleUrls: ['./chip.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChipComponent<T> {
    @Input() value: T;
    @Input() baseDataCy: string;
    @Output() chipDelete: EventEmitter<T> = new EventEmitter<T>();
    @Input() labelTransform: (value: T) => string;
    @Input() tooltipTemplate: TemplateRef<T>;

    get label(): string {
        let label = `${this.value}`;
        if (this.labelTransform != null) {
            label = this.labelTransform(this.value);
        }
        return label;
    }

    get tooltipString(): string {
        return `${this.value}`;
    }

    retrieveTooltipToApply(template: TemplateRef<T>): string | string[] | TemplateRef<T> {
        let tooltip: string | string[] | TemplateRef<T> = this.tooltipString;
        if (this.tooltipTemplate != null) {
            tooltip = template;
        }
        return tooltip;
    }

    chipDataCy(): string {
        const label = this.label?.replace(/ /g, '-');
        return `${this.baseDataCy}-${label}`;
    }

    onDeleteClick(): void {
        this.chipDelete.emit(this.value);
    }

}
